// The status cell — brief §4.5 (P31, P55), 2026-09-24: tint + dot + label.
//
// The chip law (brief K6): a span, `radiusPill`, `W2 Y1`. The LABEL carries
// the meaning (never colour alone), inked with the brand's semantic hue inks,
// which clear 4.5:1 in both schemes. The tint is a 10% mix of the chip's OWN
// ink (Rule 67: a tint of currentColor follows the ink per scheme — no raw
// hue, so no `raw-hue-ink` survivor), and the dot takes the ink. A status
// with no hue is the same rule over `caption`: a neutral plate.
//
//   status: 'success' → `successInk`   status: 'danger' → `dangerInk`
//   status: 'warning' → `warningInk`   no status        → `caption`
//
// Contrast is computed in __tests__/tableKit.test.js from the brand values:
// every ink on its own tint, on the white and on the dark card.
//
// A new primitive, not an extension: the default-library BulletCaption /
// StatusDot / Badge are not linked into these apps (their registry has none
// of them), and the shared badges are single-purpose (InstallableStateBadge,
// ConnectionBadge).
export const AppStatusChip = {
  tag: 'span',
  flow: 'x',
  align: 'center',
  gap: 'X2',
  width: 'fit-content',
  padding: 'W2 Y1',
  round: 'radiusPill',
  fontSize: 'Y1',
  fontWeight: '500',
  lineHeight: '1',
  whiteSpace: 'nowrap',
  background: 'color-mix(in srgb, currentColor 10%, var(--color-tintBase))',
  color: 'caption',

  isSuccess: (el, s) => (el.status ?? s?.status) === 'success',
  isDanger: (el, s) => (el.status ?? s?.status) === 'danger',
  isWarning: (el, s) => (el.status ?? s?.status) === 'warning',
  '.isSuccess': { color: 'successInk' },
  '.isDanger': { color: 'dangerInk' },
  '.isWarning': { color: 'warningInk' },

  Dot: {
    tag: 'span',
    'aria-hidden': true,
    boxSize: 'Y1',
    flexShrink: '0',
    round: 'radiusPill',
    background: 'currentColor'
  },

  // A bundle key or a plain string: polyglot returns a non-key verbatim.
  Label: {
    tag: 'span',
    text: (el, s) => el.call('polyglot', el.parent?.label ?? s?.label ?? '')
  }
}
